import React from 'react';
import Head from 'next/head';
import { BootstrapLoadingWrapper } from 'components/BootstrapLoadingWrapper';
import { PricingScreen } from 'screens/Pricing/PricingScreen';
import { redirectAuthenticatedUser } from 'utils/pageUtils';
import { GetServerSideProps } from 'next';
import { t } from 'translations/t';

export const getServerSideProps: GetServerSideProps = redirectAuthenticatedUser;

export default function Pricing() {
  return (
    <>
      <Head>
        <title>{t('web.metadata.pricing.title')}</title>
        <meta name="description" content={t('web.metadata.desc1')} />
      </Head>
      <BootstrapLoadingWrapper>
        <PricingScreen />
      </BootstrapLoadingWrapper>
    </>
  );
}
